import React, { useState } from "react";
import { productService } from "../services/product.service";

const AdminAddProduct = () => {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [desc, setDesc] = useState("");
  const [formType, setFormType] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // ⭐ NAVBAR İLE %100 AYNI SLUG'LAR
  const categoryMap = {
    Vitaminler: [
      { name: "C Vitamini (Ester-C)", slug: "c-vitamini" },
      { name: "D Vitamini & K2", slug: "d-vitamini-k2" },
      { name: "Multivitaminler", slug: "multivitaminler" },
      { name: "B Kompleks", slug: "b-kompleks" },
      { name: "Saç & Tırnak (Biotin)", slug: "sac-tirnak-biotin" }
    ],
    Mineraller: [
      { name: "Magnezyum", slug: "magnezyum" },
      { name: "Çinko (Zinc)", slug: "cinko-zinc" },
      { name: "Demir (Gentle Iron)", slug: "demir" },
      { name: "Selenyum", slug: "selenyum" },
      { name: "Kalsiyum", slug: "kalsiyum" }
    ],
    Bitkisel: [
      { name: "Zerdeçal (Curcumin)", slug: "zerdecal" },
      { name: "Deve Dikeni", slug: "deve-dikeni" },
      { name: "Ginseng", slug: "ginseng" },
      { name: "Ekinezya", slug: "ekinezya" }
    ]
  };

  // ⭐ CLOUDINARY
  const uploadImageToCloudinary = async () => {
    const data = new FormData();
    data.append("file", imageFile);
    data.append("upload_preset", process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);

    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
      { method: "POST", body: data }
    );

    const fileData = await res.json();
    return fileData.secure_url;
  };

  // ⭐ ÜRÜN KAYDETME
  const handleAddProduct = async () => {
    if (!name || !price || !desc || !formType || !category || !subCategory || !imageFile) {
      return alert("Tüm alanları doldurmanız gerekiyor!");
    }

    setLoading(true);

    try {
      const imgURL = await uploadImageToCloudinary();

      await productService.addProduct({
        name,
        price: Number(price),
        desc,
        form: formType,
        category: subCategory, // ⭐ NAVBAR SLUG'I
        image: imgURL,
        isActive: true, // Auto-active for visibility on storefront
        inStock: true,
      });

      setSuccess(true);
      setName("");
      setPrice("");
      setDesc("");
      setFormType("");
      setCategory("");
      setSubCategory("");
      setImageFile(null);

      // Auto-hide success message
      setTimeout(() => setSuccess(false), 3000);

    } catch (err) {
      console.log("HATA:", err);
      alert("Ürün eklenirken bir hata oluştu: " + err.message);
    }

    setLoading(false);
  };

  const subCategoryList = category ? categoryMap[category] : [];

  return (
    <div className="p-10 max-w-xl mx-auto bg-white rounded-xl shadow">
      <h2 className="text-2xl font-bold mb-6">Yeni Ürün Ekle</h2>

      <input
        type="text"
        placeholder="Ürün Adı"
        className="w-full p-3 border rounded mb-3"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <input
        type="number"
        placeholder="Fiyat"
        className="w-full p-3 border rounded mb-3"
        value={price}
        onChange={(e) => setPrice(e.target.value)}
      />

      <textarea
        placeholder="Açıklama"
        className="w-full p-3 border rounded mb-3"
        value={desc}
        onChange={(e) => setDesc(e.target.value)}
      />

      <select
        className="w-full p-3 border rounded mb-3"
        value={formType}
        onChange={(e) => setFormType(e.target.value)}
      >
        <option value="">Form Seç</option>
        <option>Tablet</option>
        <option>Kapsül</option>
        <option>Sıvı</option>
        <option>Çiğneme Tablet</option>
      </select>

      <select
        className="w-full p-3 border rounded mb-3"
        value={category}
        onChange={(e) => {
          setCategory(e.target.value);
          setSubCategory("");
        }}
      >
        <option value="">Ana Kategori Seç</option>
        <option value="Vitaminler">Vitaminler</option>
        <option value="Mineraller">Mineraller</option>
        <option value="Bitkisel">Bitkisel</option>
      </select>

      <select
        className="w-full p-3 border rounded mb-3"
        value={subCategory}
        onChange={(e) => setSubCategory(e.target.value)}
        disabled={!category}
      >
        <option value="">Alt Kategori Seç</option>
        <option value="">Alt Kategori Seç</option>
        {subCategoryList.map((sub, i) => (
          <option key={i} value={sub.slug}>
            {sub.name}
          </option>
        ))}
      </select>

      <input
        type="file"
        className="w-full p-3 border rounded mb-3 mt-4"
        onChange={(e) => setImageFile(e.target.files[0])}
      />

      <button
        onClick={handleAddProduct}
        disabled={loading}
        className={`w-full text-white py-3 rounded font-bold ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'}`}
      >
        {loading ? "Yükleniyor..." : "Ürünü Kaydet"}
      </button>

      {success && (
        <p className="text-green-700 font-bold mt-4 animate-in fade-in slide-in-from-bottom-2">
          ✔ Ürün başarıyla eklendi!
        </p>
      )}
    </div>
  );
};

export default AdminAddProduct;
